import React from 'react';
import { Calendar } from 'lucide-react';
import CalendarView from './CalendarView';
import PageHeader from './common/PageHeader';

function ScheduleHub({ user }) {
    return (
        <div style={styles.container}>
            <PageHeader icon={Calendar} title="일정" />
            <CalendarView user={user} />
        </div>
    );
}

const styles = {
    container: { padding: '24px', maxWidth: 1200, margin: '0 auto' },
};

export default ScheduleHub;
